__turbopack_context__.v({
  "heading": "ChartLegend-module__KDtH2a__heading",
  "item": "ChartLegend-module__KDtH2a__item",
  "lineSwatch": "ChartLegend-module__KDtH2a__lineSwatch",
  "list": "ChartLegend-module__KDtH2a__list",
  "root": "ChartLegend-module__KDtH2a__root",
  "swatch": "ChartLegend-module__KDtH2a__swatch",
});
